import React, { useState } from "react";
import { toast } from "react-toastify";
import { Base64 } from "js-base64";
import MainLayout from "../../layouts/MainLayOut";
import OTPInput from "react-otp-input";
import { GetOtpForForget, SaveForPass, VerifyOtpForForget } from "../../apis";
import { useNavigate } from "react-router-dom";

const Forget = () => {
  const [step, setStep] = useState("email"); // 'email' | 'otp' | 'reset'
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();

  const handleSendOtp = async () => {
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      toast.error("Please enter a valid email");
      return;
    }
    try {
      const res = await GetOtpForForget(email);
      if (!res.error) {
        toast.success("OTP sent successfully!");
        setStep("otp");
      } else {
        toast.error(res.data || "Failed to send OTP");
      }
    } catch (err) {
      toast.error("Network error while sending OTP");
    }
  };

  const handleVerifyOtp = async () => {
    const res = await VerifyOtpForForget(email, otp);

    if (!res.error) {
      toast.success("OTP verified");
      setStep("reset");
    } else {
      toast.error(res.data || "Invalid OTP");
    }
  };

  const handleResetPassword = async () => {
    if (!newPassword || !confirmPassword) {
      toast.error("Please fill both password fields");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      const res = await SaveForPass(email, newPassword);

      if (!res.error) {
        toast.success("Password reset successfully!");
        setStep("email");
        setEmail("");
        setOtp("");
        setNewPassword("");
        setConfirmPassword("");
        sessionStorage.removeItem("fp_otp");

        navigate("/login"); // ✅ Move here after success
      } else {
        toast.error(res.data || "Reset failed");
      }
    } catch (err) {
      console.error("Error in handleResetPassword:", err);
      toast.error("Network error during password reset");
    }
  };

  return (
    <MainLayout>
      <div className="w-full max-w-md mx-auto p-6 my-10 rounded-xl bg-white shadow-md border border-gray-200">
        <h2 className="text-2xl font-bold mb-4 text-center">Forgot Password</h2>

        {step === "email" && (
          <>
            <label className="block mb-2 text-sm font-semibold text-gray-700">
              Your Email
            </label>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              className="w-full border px-3 py-2 mb-4 rounded"
              onChange={(e) => setEmail(e.target.value)}
            />
            <button
              className="w-full hover:bg-primary bg-darkprimary text-white py-2 rounded"
              onClick={handleSendOtp}>
              Send OTP
            </button>
          </>
        )}

        {step === "otp" && (
          <>
            <label className="block mb-2 text-sm font-semibold text-gray-700">
              Your Email
            </label>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              disabled
              className="w-full border px-3 py-2 mb-4 rounded bg-gray-100 text-gray-500 cursor-not-allowed"
            />

            <label className="text-sm font-medium text-gray-700 mb-1 block text-center">
              Enter the 6-digit OTP sent to your email
            </label>

            <OTPInput
              value={otp}
              onChange={setOtp}
              numInputs={6}
              isInputNum
              shouldAutoFocus
              containerStyle="flex justify-center gap-2 mb-4"
              renderInput={(props) => (
                <input {...props} className="otp-input" />
              )}
            />

            <button
              className="w-full bg-green-600 hover:bg-green-700 text-white py-2 rounded transition"
              onClick={handleVerifyOtp}>
              Verify OTP
            </button>
          </>
        )}

        {step === "reset" && (
          <>
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              className="w-full border px-3 py-2 mb-2 rounded"
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <input
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              className="w-full border px-3 py-2 mb-4 rounded"
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <button
              className="w-full bg-purple-600 text-white py-2 rounded"
              onClick={handleResetPassword}>
              Reset Password
            </button>
          </>
        )}
      </div>
    </MainLayout>
  );
};

export default Forget;
